// extracted by mini-css-extract-plugin
export default {"attrImage":"Legal_attrImage__FfAr+","attributes":"Legal_attributes__TR9m3","author":"Legal_author__PRltR"};